// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  // DialogContentText,
  DialogTitle,
  DialogActions,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";

import PushNotificationMgr from "app/components/push_notification_mgr";

function Inbox() {
  const pageTitle = "My Inbox";
  usePageTitle(pageTitle);

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [allowPushNotificationDialogState, setAllowPushNotificationDialogState] = useState(false);

  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);

  const tableColumns = [
    { Header: "View", accessor: "action", align: "left" },
    { Header: "Subject", accessor: "subject", align: "left" },
    { Header: "From", accessor: "sender", align: "left" },
    { Header: "Date", accessor: "created", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        action: (
          <MDButton
            size="small"
            variant="outlined"
            color={row.read ? "dark" : "success"}
            iconOnly
            onClick={() => {
              setSelectedMessage(row);
              setOpenMessageDialog(true);
            }}
          >
            <Icon sx={{ cursor: "pointer" }} fontSize="small">
              {row.read ? "email" : "mark_email_unread"}
            </Icon>
          </MDButton>
        ),
        sender: row.message.sender,
        subject: row.message.subject,
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/inbox/messages.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRows(result.data.data.messages);
            setMessages(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function markMessageRead() {
    setShowLoading(true);

    const json = {
      reference: `${selectedMessage.reference}`,
    };

    await axios
      .post("agents/inbox/messages/markRead.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  // const [openNotificationAllowPromptDialog, setOpenNotificationAllowPromptDialog] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PushNotificationMgr
        displayState={allowPushNotificationDialogState}
        setDisplayState={setAllowPushNotificationDialogState}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      {selectedMessage ? (
        <Dialog open={openMessageDialog} fullWidth>
          <DialogTitle>
            <MDBox>
              <MDBox>
                <MDTypography variant="h6" fontWeight="light">
                  <Icon color="info">label_important</Icon>&nbsp;
                  <strong>{selectedMessage.message.sender}</strong>
                </MDTypography>
              </MDBox>
              <MDBox mt={2}>
                <MDTypography variant="h6" fontWeight="light">
                  <Icon color="dark">subject</Icon>&nbsp;{selectedMessage.message.subject}
                </MDTypography>
              </MDBox>
            </MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                <div dangerouslySetInnerHTML={{ __html: selectedMessage.message.message_body }} />
              </MDTypography>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenMessageDialog(false);
                if (!selectedMessage.read) {
                  markMessageRead();
                }
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox ml={3} mr={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDTypography variant="h6" fontWeight="medium">
                              My Inbox
                            </MDTypography>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={1}>
                        <DataTable
                          table={{ columns: tableColumns, rows: messages }}
                          isSorted
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Inbox;
